export default {
  title: 'Transfer',
  alert: {
    message: 'Please complete the KYC verification before withdrawing.',
    'button-text': 'Go to KYC',
  },
  tabs: {
    title: {
      innerTransfer: 'Inner Transfer',
      outerTransfer: 'Outer Transfer',
    },
  },
  form: {
    tips: {
      title: 'Arrival Amount',
      rate: 'Rate',
    },
    sourceAccountId: {
      label: 'Source Account',
      placeholder: 'Please select source account',
      rule: {
        required: 'Please select source account',
      },
      account_type: {
        wallet: 'Wallet Account',
        MT: 'MT Account',
        MT4: 'MT4',
        MT5: 'MT5',
      },
      account_detail: '{wallet_id}-{balance} {currency}',
    },
    targetAccountId: {
      label: 'Target Account',
      placeholder: 'Please select destination account',
      rule: {
        required: 'Please select destination account',
      },
      account_type: {
        wallet: 'Wallet Account',
        MT: 'MT Account',
        MT4: 'MT4',
        MT5: 'MT5',
      },
      account_detail: '{wallet_id}-{balance} {currency}',
    },
    targetAccountEmail: {
      label: 'Target Account Email',
      placeholder: 'Please enter email',
      rule: {
        required: 'Please enter email',
        invalid: 'Please enter a valid email',
      },
    },
    amount: {
      label: 'Amount',
      placeholder: 'Please enter transfer amount',
      rule: {
        required: 'Please enter transfer amount',
        min: 'Transfer amount cannot be less than 0.01',
      },
    },
    password: {
      label: 'Password',
      placeholder: 'Please enter password',
      rule: {
        required: 'Please enter password',
      },
    },

    button: {
      submit: 'Confirm Transfer',
    },
  },
  modal: {
    securityVerification: {
      title: 'Security Verification',
      confirm: 'Confirm',
      cancel: 'Cancel',
      emailVerifyCodeLabel: 'Email Verify Code',
      app: 'App Verification',
      phone: 'Phone Verification',
      verifyCodeLabel: 'Verify Code',
    },
  },
}
